/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Rate_YearlyInputs */

const en_rental_rate_yearly = /** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly Rate (per night)`)
};

const es_rental_rate_yearly = /** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifa Anual (por noche)`)
};

const fr_rental_rate_yearly = /** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif annuel (par nuit)`)
};

const de_rental_rate_yearly = /** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahresrate (pro Nacht)`)
};

const id_rental_rate_yearly = /** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif Tahunan (per malam)`)
};

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const ja_rental_rate_yearly = en_rental_rate_yearly;

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const zh_rental_rate_yearly = en_rental_rate_yearly;

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const ar_rental_rate_yearly = en_rental_rate_yearly;

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const it_rental_rate_yearly = en_rental_rate_yearly;

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const ru_rental_rate_yearly = en_rental_rate_yearly;

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const pt_rental_rate_yearly = en_rental_rate_yearly;

/** @type {(inputs: Rental_Rate_YearlyInputs) => LocalizedString} */
const ko_rental_rate_yearly = en_rental_rate_yearly;

/**
* | output |
* | --- |
* | "Yearly Rate (per night)" |
*
* @param {Rental_Rate_YearlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_rate_yearly = /** @type {((inputs?: Rental_Rate_YearlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Rate_YearlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_rate_yearly(inputs)
	if (locale === "es") return es_rental_rate_yearly(inputs)
	if (locale === "fr") return fr_rental_rate_yearly(inputs)
	if (locale === "de") return de_rental_rate_yearly(inputs)
	if (locale === "ja") return ja_rental_rate_yearly(inputs)
	if (locale === "zh") return zh_rental_rate_yearly(inputs)
	if (locale === "ar") return ar_rental_rate_yearly(inputs)
	if (locale === "id") return id_rental_rate_yearly(inputs)
	if (locale === "it") return it_rental_rate_yearly(inputs)
	if (locale === "ru") return ru_rental_rate_yearly(inputs)
	if (locale === "pt") return pt_rental_rate_yearly(inputs)
	return ko_rental_rate_yearly(inputs)
});